import React from "react";

/**
 * getText: Extracts text from content.
 * If content is an array (of sentence objects or strings), it joins them.
 * Otherwise, it returns the content directly.
 */
export function getText(content: any): string {
  if (Array.isArray(content)) {
    return content
      .map((s: any) => (typeof s === "string" ? s : s.text))
      .join(" ");
  }
  return content;
}

/**
 * parseBold: Parses text wrapped in ** markers into an array of React nodes,
 * replacing them with <strong> elements.
 */
export function parseBold(text: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let keyIndex = 0;
  const boldRegex = /\*\*(.+?)\*\*/g;
  let match: RegExpExecArray | null;
  while ((match = boldRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.substring(lastIndex, match.index));
    }
    nodes.push(<strong key={`bold-${keyIndex++}`}>{match[1]}</strong>);
    lastIndex = boldRegex.lastIndex;
  }
  if (lastIndex < text.length) {
    nodes.push(text.substring(lastIndex));
  }
  return nodes;
}
